import $ from 'jquery';

window.goToSearch = function () {
  let type = document.getElementById('search-type').value;
  let price = document.getElementById('search-price').value;
  let location = document.getElementById('search-location').value;

  let params = new URLSearchParams();

  if (type) params.append('typ', type);
  if (price) params.append('price', price);
  if (location) params.append('lokalizacja', location);

  window.location.href = '/nieruchomosci/?' + params.toString();
};


// LOGIKA FILTROW NIERUCHOMOSCI
function getFilters() {
    return {
        type: document.getElementById('filter-type').value,
        price: document.getElementById('filter-price').value,
        rooms: document.getElementById('filter-rooms').value,
        sea: document.getElementById('filter-sea').value,
        sort: document.getElementById('filter-sort').value,
    };
}

function filterProperties() {
    const filters = getFilters();

    // 🔥 pokaż reset jeśli coś wybrane
    const hasFilters = Object.entries(filters).some(([key, val]) => {
        if (key === 'sort') return false;
        return val !== '';
    });

    document.getElementById('reset-filters').style.display = hasFilters ? 'inline-block' : 'none';

    // 🔥 reset paginacji → zawsze wracamy na 1 stronę
    loadProperties(1);
}
function loadProperties(paged = 1, shouldScroll = false) {
    const ctx = getContext();
     const data = {
        action: 'filter_properties',

        type: document.getElementById('filter-type')?.value || '',
        price: document.getElementById('filter-price')?.value || '',
        rooms: document.getElementById('filter-rooms')?.value || '',
        sea: document.getElementById('filter-sea')?.value || '',
        sort: document.getElementById('filter-sort')?.value || '',
        paged: paged,

        // 🔥 KLUCZ FIX
        postType: ctx.postType,
        term: ctx.term,
        taxonomy: ctx.taxonomy
    };

    document.getElementById('ajax-properties').innerHTML = 'Ładowanie...';

    fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
    })
    .then(res => res.json())
    .then(data => {

        // 🔥 HTML
        document.getElementById('ajax-properties').innerHTML = data.html;

        // 🔥 COUNT
        const countEl = document.getElementById('results-count');
        const counttxt = document.getElementById('results-txt');

        if (countEl) {
            countEl.innerText = data.count;
        }

        // 🔥 PLURAL
        if (counttxt) {
            const count = parseInt(data.count) || 0;

            let word = 'ofert';

            if (count === 1) {
                word = 'ofertę';
            } else if (
                count % 10 >= 2 &&
                count % 10 <= 4 &&
                !(count % 100 >= 12 && count % 100 <= 14)
            ) {
                word = 'oferty';
            }

            counttxt.innerText = word;
        }

        // 🔥 PAGINATION REBIND
        initPaginationLinks();

        // 🔥 SCROLL (TYLKO GDY TRZEBA)
        if (shouldScroll) {
            document.getElementById('ajax-properties')
                .scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
}



// paginacja ajax
function initPaginationLinks() {
    document.querySelectorAll('.pagination-wrapper a').forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const page = this.dataset.page || this.textContent;

            loadProperties(page, true);
        });
    });
}

// start
document.addEventListener('DOMContentLoaded', function () {
    initPaginationLinks();
});

function getContext() {
    const el = document.getElementById('ajax-properties');

    return {
        postType: el?.dataset.postType || 'nieruchomosci',
        term: el?.dataset.term || '',
        taxonomy: el?.dataset.taxonomy || ''
    };
}

function fetchFilteredProperties(data = {}) {

    const formData = new FormData();

    formData.append('action', 'filter_properties');

    // filtry
    formData.append('type', document.querySelector('[name="type"]')?.value || '');
    formData.append('price', document.querySelector('[name="price"]')?.value || '');
    formData.append('rooms', document.querySelector('[name="rooms"]')?.value || '');
    formData.append('sea', document.querySelector('[name="sea"]')?.value || '');
    formData.append('sort', document.querySelector('[name="sort"]')?.value || '');

    if (data.paged) {
        formData.append('paged', data.paged);
    }

    fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData
    })
    .then(res => res.text())
    .then(html => {
        document.querySelector('#ajax-properties').innerHTML = html;
    });
}


function resetFilters() {
    document.querySelectorAll('.filters-bar select').forEach(select => {
        select.value = '';
    });

    document.getElementById('filter-sort').value = 'default';

    document.getElementById('reset-filters').style.display = 'none';

    filterProperties();
}

document.querySelectorAll('.filter-input').forEach(el => {
    el.addEventListener('change', () => {
        fetchFilteredProperties();
    });
});

window.filterProperties = filterProperties;
window.loadProperties = loadProperties;
window.initPaginationLinks = initPaginationLinks;
window.resetFilters = resetFilters;



// animacja filtrow mobile
const body = document.body;
const btn = document.querySelector('.filters-btn');
const closeBtn = document.querySelector('.filters-close');
const overlay = document.querySelector('.filters-overlay');

function openFilters() {
  body.classList.add('filters-open');
  $('#header').hide();
}

function closeFilters() {
    body.classList.remove('filters-open');
    $('#header').show();
}
if (btn) {
    btn.addEventListener('click', openFilters);
    closeBtn.addEventListener('click', closeFilters);
    overlay.addEventListener('click', closeFilters);
}